import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteUserApi } from '../Api'; // Adjust the import path as necessary

const DeleteAccountButton = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      await deleteUserApi();
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      alert('Account deleted successfully.');
      navigate('/');
    } catch (err) {
      alert('Failed to delete account: ' + err.message);
    }
  };

  return (
    <>
      {/* Trigger Button */}
      <button
        className="btn btn-outline-danger animate__animated animate__pulse"
        onMouseEnter={e => e.currentTarget.classList.add('animate__pulse')}
        onMouseLeave={e => e.currentTarget.classList.remove('animate__pulse')}
        onClick={() => setShowModal(true)}
        style={{ transition: 'box-shadow 0.3s' }}
      >
        Delete Account
      </button>

      {/* Modal */}
      {showModal && (
        <div
          className="modal show fade d-block animated-modal"
          tabIndex="-1"
          onClick={() => setShowModal(false)}
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delete Account</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  This action is <strong>permanent</strong>. Are you sure?
                </p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => {
                    setShowModal(false);
                    handleDelete();
                  }}
                >
                  Confirm Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeleteAccountButton;
